'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _LogoutIcon = _interopRequireDefault(require("Icons/LogoutIcon"));
var _Sidebar = _interopRequireDefault(require("Components/Navigation/Sidebar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  app,
  qwest
} = window;
class Back extends _react.Component {
  state = {
    is_sidebar_open: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      is_sidebar_open: localStorage.getItem('is_sidebar_open') === 'true'
    });
  }
  toggleSideBar = e => {
    const component = this,
      props = this.props,
      state = this.state;
    localStorage.setItem('is_sidebar_open', !state.is_sidebar_open);
    component.setState({
      is_sidebar_open: !state.is_sidebar_open
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      // Update user permissions now that user is disconnected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'logout'
      });
      app.navigateTo(response.pathname);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const MenuIcon = state.is_sidebar_open ? _Close.default : _Menu.default;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "back-page"
    }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
      position: "fixed"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-header__menu-actions"
    }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      color: "inherit",
      "aria-label": "Menu",
      onClick: component.toggleSideBar
    }, /*#__PURE__*/_react.default.createElement(MenuIcon, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "inherit",
      classes: {
        root: 'o-header__title'
      }
    }, "Menu")), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-header__title"
    }, props.page_title, /*#__PURE__*/_react.default.createElement(_LogoutIcon.default, {
      onClick: component.logout,
      className: "o-header__logout\r u-margin-right-10 u-margin-left-10"
    })))), /*#__PURE__*/_react.default.createElement(_Sidebar.default, _extends({}, props, {
      open: state.is_sidebar_open
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "page-content"
    }, props.children));
    return output;
  }
}
exports.default = Back;
